export const USER_STATUSES = {
  // TODO change to incomplete after the API fixes
  INCOMPLETE: "incomplete",
  INACTIVE: "inactive",
  ACTIVE: "active",
  INVITED: "invited",
  INVITE_EXPIRED: "invite expired"
};

export const USER_TYPES = [
  {
    label: "Internal",
    value: "client"
  },
  {
    label: "Candidate",
    value: "worker"
  }
];

export const USER_LIST_FILTERS = {
  detailed_status: "Status",
  role: "Roles"
};
